import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './DPSModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class DPSModal extends Component {
	render() { 
		let royalty = '';
		if (this.props.dps_access_result.royalty_percent) {
			royalty = this.props.dps_access_result.royalty_percent;
		}
		return ( 
			<div>
		  		<Modal
					isOpen={this.props.isShowModal}
					toggle={this.props.toggleModal}
				  	className="showtix-event__modal__mti"
				>
		          	<ModalHeader>{strings.title}</ModalHeader>
		          	<ModalBody>
                        <p>{strings.description}</p>
						<p className="showtix-subtitle">{this.props.client.client_name}</p>
                        <p>{strings.description2}</p>
						<p className="showtix-subtitle">{this.props.dps_access_result.show_name}.</p>
						<hr />
						{royalty > 0 && (
							<p>{strings.formatString(strings.description3, royalty)}</p>
						)}
						<p>{strings.description4}</p>
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={() => this.props.acceptRoyalties('Y')}
						>
							<span>{strings.yes}</span>
						</button>
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-2"
							onClick={() => this.props.acceptRoyalties('N')}
						>
							<span>{strings.no}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}
 
export default DPSModal;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/DPSModal/DPSModal.js